module.exports = __webpack_public_path__ + "static/media/coming-soon.477889c1.jpg";